// packages/web/src/api/me/mutations.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { meMfaVerify, meWeekSubmit } from "../generated/sdk.gen.ts";
import type { MeMfaVerifyData } from "../generated/types.gen.ts";
import { meKeys } from "./keys.ts";

type VerifyBody = NonNullable<MeMfaVerifyData["body"]>;

export function useSubmitWeek(userId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (weekISO: string) => {
      const { data, error } = await meWeekSubmit({ path: { weekISO } });
      if (error) throw error;
      if (!data) throw new Error("Submit failed");
      return data;
    },
    onSuccess: (_d, weekISO) => qc.invalidateQueries({ queryKey: meKeys.week(userId, weekISO) }),
  });
}

export function useVerifyMfa() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { body: VerifyBody }) => {
      const { data, error } = await meMfaVerify({ body: vars.body });
      if (error) throw error;
      if (!data) throw new Error("No response data");
      return data;
    },
    onSuccess: async () => {
      await Promise.all([
        qc.invalidateQueries({ queryKey: ["users"] }),
        qc.invalidateQueries({ queryKey: ["me"] }),
      ]);
      // _authed.beforeLoad gates on session.user.twoFactorEnabled and reads
      // from the ["session"] cache. Refetch (not just invalidate) so the
      // next navigation sees the fresh flag and skips the /onboarding/mfa
      // redirect.
      await qc.refetchQueries({ queryKey: ["session"] });
    },
  });
}
